module.exports = __webpack_public_path__ + "american_star_white.png";


//////////////////
// WEBPACK FOOTER
// ./images/american_star_white.png
// module id = 176
// module chunks = 0